import { Component, ViewChild } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { firstValueFrom, Observable, Subscription, take } from 'rxjs';
import { FilterRequest } from 'src/app/features/shared/models/Filter/FilterRequest';
import { SystemAlarmsCatalogKeys } from '../../models/SystemAlarmsCatalogKeys copy';
import { SystemAlarmService } from '../../services/SystemAlarm.service';
import { AlarmCatalogPaginationRequest } from 'src/app/features/shared/models/CatalogPagination/AlarmCatalogPaginationRequest';

import { environment } from "src/environments/environment";
import { GenericTableComponent } from 'src/app/features/ui/organisms/generic-table/components/generic-table.component';

@Component({
  selector: 'system-alarms-list',
  templateUrl: './system-alarms-list.component.html',
  styleUrls: ['./system-alarms-list.component.css']
})
export class SystemAlarmsListComponent {
  @ViewChild(GenericTableComponent) child;
    
      columnHeader: SystemAlarmsCatalogKeys = {
        IdLog: { displayName: "IdLog", filterable: false, activeFilter: null },
        CreatedIn: { displayName: "Fecha", filterable: true, activeFilter: null },
        Hour: { displayName: "Hora", filterable: false, activeFilter: null },
        Identifier: { displayName: "Identificador", filterable: true, activeFilter: null },
        TotalTime: { displayName: "Tiempo Atn", filterable: false, activeFilter: null },
        StatusAlarm: { displayName: "Estado", filterable: false, activeFilter: null },
        AlarmLogDetails: { displayName: "Detalles", filterable: false, activeFilter: null },
        Actions: { displayName: "Acciones", filterable: false, activeFilter: null },
      };
    
      catalogPaginationRequest: AlarmCatalogPaginationRequest = {
        page: 1,
        dato: "",
        getInactive: false,
        getSystem: true,
        filters: []
      }
    
      hasInactives: boolean = true;
      hasEditables: boolean = false;
      hasDeletables: boolean = false;
      filtersRequest : FilterRequest[] = [];
      filterOptions: { [key: string]: string[] } = {};
    
      tableData$: Observable<any[]> = new Observable<any[]>();
      tableData: any[];
      controllerName: string = "SystemAlarm";
      paginador: number;
    
      subscription_getData: Subscription;
      subscription_getDataCount: Subscription;
      subscription_getDataFileterValues: Subscription;
    
      constructor(public systemAlarmCatalogService: SystemAlarmService) {
      }
    
      ngOnInit() {
        this.EndSubscriptions();
        this.getFilters();
        this.getData();
      }
    
      ngOnDestroy(): void {
        this.EndSubscriptions();
      }
    
      EndSubscriptions(){
        if(this.subscription_getData)
          this.subscription_getData.unsubscribe();
        if(this.subscription_getDataCount)
          this.subscription_getDataCount.unsubscribe();
        if(this.subscription_getDataFileterValues)
          this.subscription_getDataFileterValues.unsubscribe();
      }
    
      getFilters(){
        var filterKeys = Object.keys(this.columnHeader).filter(key => this.columnHeader[key].filterable);
        this.filtersRequest = filterKeys.map(key => ({
          key: key,
          value: "" 
        }));
        this.subscription_getDataFileterValues = this.systemAlarmCatalogService.getFilterValues(this.filtersRequest).subscribe({
          next: (data) => {
            if (data && data.result){
              filterKeys.forEach(column => {
                this.filterOptions[column] = data.result.find(x => x.key == column).values;
              });
              if(!environment.production) console.log("filterValues datos",data, this.filterOptions);
            }else{
              Sentry.captureMessage('alarms-list.getFilters: no data', { level: 'warning', extra: { response: data } });
            }
          },
          error: (error) => {
            // TODO marca para complete despues
            console.error('Error trayrendo filter values', error);
          }
        });
      }
    
      async getData(){
        const [getCount, getData] = await Promise.all([
                firstValueFrom(this.systemAlarmCatalogService.getCount(this.catalogPaginationRequest).pipe(take(1))),
                firstValueFrom(this.systemAlarmCatalogService.getPage(this.catalogPaginationRequest).pipe(take(1)))
              ]);
                    
        if (getCount.isSuccess) {
          this.paginador = getCount.result[0];
        } else {
          Sentry.captureMessage('SystemAlarmsList.getData: getCount isSuccess false', { level: 'warning', extra: { response: getCount } });
        }

        if (getData.isSuccess) {
          this.tableData = getData.result;
          this.tableData.map((item) => {
            item['IsEditable'] = this.hasEditables;
            item['IsDeletable'] = this.hasDeletables;
          });
          this.child.setData(this.tableData, this.paginador);
        } else {
          Sentry.captureMessage('SystemAlarmsList.getData: getData isSuccess false', { level: 'warning', extra: { response: getData } });
        }

        // this.subscription_getDataCount = this.systemAlarmCatalogService.getCount(this.catalogPaginationRequest).subscribe(data=>{
        //   if(!environment.production) console.log("alarm datos",data);
        //   this.paginador = data.result[0];
        // },(error)=>{
    
        // });
        // this. subscription_getData = this.systemAlarmCatalogService.getPage(this.catalogPaginationRequest).subscribe(data=>{
        //   if(!environment.production) console.log("alarm page 1",data);
        //   if(data.isSuccess==true)
        //   {
        //     // Apply condition on edit and delete button
        //   this.tableData = data.result;
        //   this.tableData.map(item => {
        //     item['IsEditable'] = this.hasEditables;
        //     item['IsDeletable'] = this.hasDeletables;
        //   });
        //   this.child.setData(this.tableData, this.paginador);
    
        //   }
        // },(error)=>{
    
        // });
      }
}
